module.exports = __webpack_public_path__ + "img/surf.03a41200.svg";